import {DatePicker, Input, Radio} from "antd";
import {useState} from "react";

const AccountSecurity = ({}) => {
    const [firstname, setFirstname] = useState(null);
    const [lastname, setLastname] = useState(null);
    const [birthday, setBirthday] = useState(null);
    const [phone, setPhone] = useState(null);
    const [address, setAddress] = useState(null);
    const [email, setEmail] = useState(null);
    const [gender, setGender] = useState(["Nam", "Nữ"]);

    return (
        <div className={"w-full p-4"}>
            <h2 className={"font-semibold text-2xl mb-4"}>Thông tin bảo mật</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-sm font-medium text-gray-600">Họ và đệm</label>
                    <Input placeholder={"Nhập họ và đệm"}/>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600">Tên</label>
                    <Input placeholder={"Nhập tên"}/>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-sm font-medium text-gray-600">Email liên hệ</label>
                    <Input placeholder={"Nhập Email"}/>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600">SĐT liên hệ</label>
                    <Input placeholder={"Nhập số điện thoại"}/>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-sm font-medium text-gray-600">Ngày sinh</label>
                    <DatePicker placeholder={"Nhập ngày sinh"} className="w-full" format="DD/MM/YYYY"/>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600">Địa chỉ</label>
                    <Input defaultValue="114/188 Tô Ngọc Vân, Gò Vấp, HCM."/>
                </div>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-600">Giới tính</label>
                <Radio.Group>
                    {gender.map((item, index) => (
                        <Radio key={index} value={item}>{item}</Radio>
                    ))}
                </Radio.Group>
            </div>
        </div>
    )
}

export default AccountSecurity;